/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PushNotificationCredentialsInput } from '../../models/push-notification-credentials-input';
import { SmsNotificationCredentialsInput } from '../../models/sms-notification-credentials-input';

export interface UpdateNotificationSettingCredentials$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
  notificationType: 'SMS';
      body: (SmsNotificationCredentialsInput | PushNotificationCredentialsInput)
}

export function updateNotificationSettingCredentials(http: HttpClient, rootUrl: string, params: UpdateNotificationSettingCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateNotificationSettingCredentials.PATH, 'put');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('notificationType', params.notificationType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateNotificationSettingCredentials.PATH = '/tenants/{tenantId}/notification-settings/{notificationType}/credentials';
